
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class BeneMobile extends Vue {
  @Prop() title!: string;
  @Prop() wrapperClass!: string;
  @Prop() fields!: any;
}
